var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 21,
    viewBox: "0 0 25 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0413 8.95643L23.0333 8.95293L1.66835 0.0913906C1.48865 0.0161762 1.29311 -0.0133219 1.09922 0.00553484C0.905323 0.0243916 0.719128 0.0910152 0.557286 0.199446C0.386295 0.311488 0.245842 0.464282 0.148564 0.644082C0.0512849 0.823881 0.000232666 1.02504 2.73146e-07 1.22947V6.89688C9.52881e-05 7.17634 0.0976797 7.44702 0.275934 7.66226C0.454188 7.8775 0.701945 8.02381 0.9765 8.07598L12.629 10.2306C12.6748 10.2393 12.7161 10.2637 12.7458 10.2995C12.7755 10.3354 12.7918 10.3806 12.7918 10.4272C12.7918 10.4738 12.7755 10.5189 12.7458 10.5548C12.7161 10.5907 12.6748 10.6151 12.629 10.6238L0.977001 12.7784C0.702522 12.8304 0.454779 12.9765 0.276445 13.1916C0.0981114 13.4066 0.00035019 13.6771 2.73146e-07 13.9565V19.6249C-0.000132583 19.8201 0.0482018 20.0123 0.140666 20.1842C0.23313 20.3561 0.366832 20.5024 0.529772 20.6099C0.725771 20.7401 0.955793 20.8097 1.19111 20.81C1.3547 20.8099 1.51662 20.777 1.66735 20.7135L23.0318 11.9024L23.0413 11.8979C23.3289 11.7743 23.5739 11.5692 23.7461 11.3078C23.9183 11.0463 24.0101 10.7402 24.0101 10.4272C24.0101 10.1142 23.9183 9.80802 23.7461 9.54662C23.5739 9.28521 23.3289 9.08002 23.0413 8.95643Z",
    fill: "#214ba5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendBlue);
export default __webpack_public_path__ + "static/media/send-blue.2f06939f5e2efd240ca49c9039fe18e3.svg";
export { ForwardRef as ReactComponent };